/* eslint-disable react/jsx-curly-brace-presence */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState, useEffect, ReactNode } from 'react';
import cls from './DropDown.module.scss';
import { classNames } from '@/shared/lib/classNames';
import { Arrow } from '@/shared/assets/icons/Arrow';
// import Arrow from '@/shared/assets/icons/dropDownArrow.svg?react';

interface Option {
    label?: string | ReactNode;
    value?: any;
    url?: string;
    logo?: boolean;
}

interface DropdownProps {
    className?: string;
    options: Option[];
    onSelect: (value: any) => void;
    placeholder?: string;
    logo?: string;
    styleType?: 'onMenu' | 'onSideMenu' | 'rightMenu';
}

export const Dropdown: React.FC<DropdownProps> = ({ className, options, onSelect, placeholder, logo, styleType = 'onMenu' }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [isMobile, setIsMobile] = useState(false);
    const [selectedLabel, setSelectedLabel] = useState(placeholder);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth > 1100);
        };
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const handleDropdownToggle = (e: React.MouseEvent<HTMLDivElement>) => {
        e.stopPropagation(); // Prevent click from bubbling up
        setIsOpen(!isOpen);
    };

    const handleOptionClick = (option: Option, e: React.MouseEvent<HTMLElement>) => {
        e.stopPropagation(); // Prevent click from bubbling up
        onSelect(option.value);
        setIsOpen(false);
    };

    return (
        <div
            className={classNames(cls.dropdown, { [cls.open]: isOpen }, [className, cls[styleType]])}
            onClick={!isMobile ? handleDropdownToggle : undefined}
            onMouseEnter={() => styleType === 'onMenu' && setIsOpen(true)}
            onMouseLeave={() => styleType === 'onMenu' && setIsOpen(false)}
        >
            {logo && (
                <div className={cls.control}>
                    {styleType === 'onSideMenu' && logo && (
                        <img
                            src={logo}
                            alt="logo"
                            style={{ marginRight: '12px', verticalAlign: 'middle', width: '52px', height: '56px' }}
                        />
                    )}
                    {styleType === 'rightMenu' && logo && (
                        <img src={logo} alt="logo" style={{ marginRight: '12px', verticalAlign: 'middle', height: '20px' }} />
                    )}
                    <p className={cls.listLabel}>
                        <span>{selectedLabel || 'Select an option'}</span>
                        {styleType === 'onSideMenu' && (
                            <Arrow
                                fill={!isOpen ? '#000' : '#15b015'}
                                className={classNames(cls.arrow, { [cls.reverseArrow]: isOpen })}
                            />
                        )}
                    </p>
                </div>
            )}

            <ul className={cls.options}>
                {options.map((option, index) => (
                    // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
                    <li key={`${index + 1}`} className={cls.option} onClick={(e) => handleOptionClick(option, e)}>
                        {option.url ? (
                            <a className={cls.link} href={option.url} rel="noopener noreferrer">
                                <span>{option.label}</span> {option.logo && <span className={cls.online}>Онлайн</span>}
                            </a>
                        ) : (
                            option.label
                        )}
                    </li>
                ))}
            </ul>
        </div>
    );
};
